import Layout from '@/components/layout/Layout.vue'
import { getRecharges, getRechargeStat, getTeamStats} from '@/api/stat'
import moment from 'moment/moment'
import Chart from 'chart.js'
import { getUser } from '@/api/user'
import { getTeams, getWorkers, getCorporations } from '@/api/open'

export default {
    components: {
        Layout,
    },
    data () {
        return {
            loading: false,
            loading2: false,
            loading3: false,
            data:[],
            showWelcome: !this.accessTo([
                'StatController@rechargeStat',
                'StatController@recharges',
            ]),
            queryParam: {
                date:[
                    moment().subtract(7, 'days').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ]
            },
            teamStatQueryParam: {
                month: moment().format('YYYY-MM')
            },
            teams: [],
            workers: [],
            channels: [],
            corporations: [],
            columns:[
                {title: '日期', dataIndex: 'day', align: 'center'},
                {title: '消耗成本', dataIndex: 'cost', align: 'center'},
                {title: '总收入', dataIndex: 'income', align: 'center'},
                {title: '新增用户数', dataIndex: 'new_user_count', align: 'center'},
                {title: '新用户充值金额', dataIndex: 'new_income', align: 'center'},
                {title: '新用户充值人数', dataIndex: 'new_paid_user_count', align: 'center'},
                {
                    title: 'ROI', dataIndex: 'roi', align: 'center', customRender: roi => {
                        roi = Number((roi * 100).toFixed(2))
                        return roi >= 100 ? <span style="color:red">{roi}%</span> : <span>{roi}%</span>
                    }
                },
                {title: '新增剧目数', dataIndex: 'new_video_count', align: 'center'},
                {title: '在投剧目数', dataIndex: 'video_count', align: 'center'},
                {title: '在投基建数', dataIndex: 'total_promotion_num', align: 'center'},
                {title: '在投有效基建数', dataIndex: 'total_effective_promotion_num', align: 'center'},
                {title: '今日有效基建数', dataIndex: 'day_effective_promotion_num', align: 'center'},
                {title: '今日新增基建数', dataIndex: 'day_promotion_num', align: 'center'},
            ],
            teamStatColumns:[
                { width:150, title: '小组名称', dataIndex: 'name' },
                {
                    width:150, title: '所属主体', dataIndex: 'corporation_id', customRender: id => {
                        return this.$helper.getItemName(this.corporations, id) || '-'
                    }
                },
                {
                    width:150, title: '今日实时消耗',  customRender: item => {
                        if (!item.day_stat) {
                            return '-'
                        }
                        return item.day_stat.total_cost || '-'
                    }
                },
                {
                    width:150, title: '今日实时roi',  customRender: item => {
                        if (!item.day_stat) {
                            return '-'
                        }
                        let roi = item.day_stat.total_cost > 0 && item.day_stat.total_income > 0 ? Number(item.day_stat.total_income / item.day_stat.total_cost * 100).toFixed(2) : '-'
                        return  !isNaN(roi) ? (roi >= 100 ? <span style="color:red">{roi}%</span> : <span style="color:green">{roi}%</span>) : '-'
                    }
                },
                {  width:350, title: '本月完成进度', dataIndex: 'month_progress' , scopedSlots: { customRender: 'month_progress' } },
                {  width:250, title: '本月排名',  customRender: item => {
                    return item.month_progress !== null ? item.month_rank : '-'
                } }
            ],
            teamStatData: [],
            pagination: {
                current:1,
                defaultPageSize: 10,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            teamStatPagination: {
                current:1,
                defaultPageSize: 10,
                showSizeChanger: true,
                onShowSizeChange: this.teamStatPageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            chartData: {labels:[],datasets:[]},
            options: {
                title: {
                    display: true,
                    text: '消耗趋势图'
                },
                scales: {
                    yAxes: [
                        {
                            id: 'left',
                            type: 'linear',
                            ticks: {
                                beginAtZero: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '金额(元)',
                                position: 'top'
                            }
                        },
                        {
                            id: 'right',
                            type: 'linear',
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                callback: function (value) {
                                    return value + '%'
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '百分比',
                                position: 'top'
                            }
                        },
                    ]
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'index',
                    intersect: false,
                },
                backgroundColor: 'transparent'
            },
            platform:localStorage.getItem('platform'),
            type:1,
            today:[],
            yesterday:[],
            data_limit: true,
        }
    },
    mounted() {
        getCorporations().then(res => { this.corporations = res.data.list || {} })
        getUser().then(res => {
            this.$store.commit('setAdmin', res.data)
            this.init()
        })
    },
    methods: {
        init() {
            this.accessTo('StatController@rechargeStat') && this.getStat()
            this.accessTo('StatController@recharges') && this.getDays()
            this.accessTo('StatController@recharges') && this.getData()
            this.accessTo('StatController@teamStat') &&  this.getTeamStatData()
            getTeams().then(res => { this.teams = res.data.list || [] })
            getWorkers().then(res => { this.workers = res.data.list || [] })
        },
        pageSizeChange(val, pageSize) {
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        handleTableChange(pagination) {
            const pager = {...this.pagination}
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        teamStatPageSizeChange(val, pageSize) {
            this.teamStatPagination.defaultPageSize = pageSize
            this.teamStatPagination.current = 1
        },
        teamStatHandleTableChange(teamStatPagination) {
            const pager = {...this.teamStatPagination}
            pager.current = teamStatPagination.current
            this.teamStatPagination = pager
            this.getTeamStatData()
        },
        changeDay(type) {
            this.type = Number(type)
            this.refresh()
        },
        getDays() {
            let startedAt = ''
            let finishedAt = moment().format('YYYY-MM-DD')
            switch (Number(this.type)) {
                case 1:
                    startedAt = moment().subtract(7, 'days').format('YYYY-MM-DD')
                    break
                case 2:
                    startedAt = moment().subtract(30, 'days').format('YYYY-MM-DD')
                    break
                case 3:
                    startedAt =  moment().subtract(60, 'days').format('YYYY-MM-DD')
                    break
            }
            this.queryParam.date = [startedAt, finishedAt]
            this.getChartData(startedAt, finishedAt)
        },
        getData() {
            this.loading = true
            const pagination = {...this.pagination}
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getRecharges(json).then(res => {
                pagination.total = res.data.total
                this.data = res.data.list
                this.pagination = pagination
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getTeamStatData() {
            if (this.teamStatQueryParam.month != moment().format('YYYY-MM')) {
                this.teamStatColumns = [
                    { width:150, title: '小组名称', dataIndex: 'name' },
                    {
                        width:150, title: '所属主体', dataIndex: 'corporation_id', customRender: id => {
                            return this.$helper.getItemName(this.corporations, id) || '-'
                        }
                    },
                    {
                        width:150, title: '月消耗',  customRender: item => {
                            if (!item.month_stat) {
                                return '-'
                            }
                            return item.month_stat.total_cost || '-'
                        }
                    },
                    {
                        width:150, title: '月roi',  customRender: item => {
                            if (!item.month_stat) {
                                return '-'
                            }
                            let roi =  item.month_stat.total_cost > 0 && item.month_stat.total_income > 0 ? Number(item.month_stat.total_income / item.month_stat.total_cost * 100).toFixed(2) : '-'
                            return  !isNaN(roi) ? (roi >= 100 ? <span style="color:red">{roi}%</span> : <span style="color:green">{roi}%</span>) : '-'
                        }
                    },
                    {  width:350, title: '本月完成进度', dataIndex: 'month_progress' , scopedSlots: { customRender: 'month_progress' } },
                    {  width:250, title: '本月排名',  customRender: item => {
                        return item.month_progress !== null ? item.month_rank : '-'
                    } }
                ]
            }

            this.loading2 = true
            const teamStatPagination = {...this.teamStatPagination}
            const json = Object.assign({}, this.teamStatQueryParam, {
                page: teamStatPagination.current,
                page_size: teamStatPagination.defaultPageSize,
            }, {corporation_id: this.queryParam.corporation_id})
            
            this.$helper.buildDateRangeParams(json, 'date')
            getTeamStats(json).then(res => {
                teamStatPagination.total = res.data.total
                this.teamStatData = res.data.list
                this.data_limit = res.data.limit
                this.teamStatData.sort((obj1, obj2) => {
                    return obj1.month_rank - obj2.month_rank;
                });

                this.teamStatPagination = teamStatPagination
                this.loading2 = false
            }).catch(() => {
                this.loading2 = false
            })
        },
        getStat(){
            const json = Object.assign({}, this.queryParam)
            this.$helper.buildDateRangeParams(json, 'date')
            this.loading3 = true
            getRechargeStat(json).then(res => {
                this.today = res.data.today
                this.yesterday = res.data.yesterday
                this.loading3 = false
            }).catch(() => {
                this.loading3 = false
            })
        },
        refresh() {
            this.getDays()
            this.getData()
            this.getStat()
            this.accessTo('StatController@teamStat') &&  this.getTeamStatData()
        },
        search() {
            this.pagination.current = 1
            this.refresh()
        },
        resetSearch() {
            this.queryParam = {}
            this.refresh()
        },
        getChartData() {
            const json = Object.assign({}, this.queryParam)
            this.$helper.buildDateRangeParams(json, 'date')
            getRecharges(json).then(res=>{
                let chartData = {}
                let labels = []
                let income = []
                let newIncome = []
                let newPaidUserCount = []
                let newUserCount = []

                let newVideoCount = []
                let videoCount = []
                let totalPromotionNumCount = []
                let dayPromotionNumCount = []
                let totalEffectivePromotionNumCount = []
                let dayEffectivePromotionNumCount = []

                let rois = []
                let cost = []
                res.data.list.forEach(item => {
                    labels.push(moment(item.day).format('YYYYMMDD'))
                    income.push(item.income)
                    newIncome.push(item.new_income)
                    newPaidUserCount.push(item.new_paid_user_count)
                    newUserCount.push(item.new_user_count)
                    cost.push(item.cost)
                    rois.push((item.roi * 100).toFixed(2))

                    newVideoCount.push(item.new_video_count)
                    videoCount.push(item.video_count)
                    totalPromotionNumCount.push(item.total_promotion_num)
                    dayPromotionNumCount.push(item.day_promotion_num)
                    totalEffectivePromotionNumCount.push(item.total_effective_promotion_num)
                    dayEffectivePromotionNumCount.push(item.day_effective_promotion_num)
                })
                chartData = {
                    labels: labels.reverse(),
                    datasets: [
                        {
                            label: 'ROI',
                            borderColor: '#ff5722',
                            backgroundColor: 'transparent',
                            yAxisID: 'right',
                            pointHoverRadius: 5,
                            data: rois.reverse()
                        },
                        {
                            label: '消耗成本',
                            borderColor: '#76BBF1',
                            backgroundColor: 'transparent',
                            yAxisID: 'left',
                            pointHoverRadius: 5,
                            data: cost.reverse(),
                        },
                        {
                            label: '总收入',
                            borderColor: '#47CACB',
                            backgroundColor: 'transparent',
                            yAxisID: 'left',
                            pointHoverRadius: 5,
                            data: income.reverse(),
                        },
                        {
                            label: '新增用户',
                            borderColor: '#CCBFE7',
                            backgroundColor: 'transparent',
                            yAxisID: 'left',
                            pointHoverRadius: 5,
                            data: newUserCount.reverse(),
                        },
                        {
                            label: '新用户充值人数',
                            borderColor: '#FFD5B6',
                            backgroundColor: 'transparent',
                            yAxisID: 'left',
                            pointHoverRadius: 5,
                            data: newPaidUserCount.reverse(),
                        },
                    ]
                }
                this.setChartData(chartData)
            })
        },
        setChartData(data){
            if (typeof(this.chart) !== 'undefined') {
                this.chart.destroy()
            }
            let chartEl = null
            chartEl = document.getElementById('lineChart')
            chartEl.height = 70
            this.chart = new Chart(chartEl, {
                type: 'line',
                data: data,
                options: {
                    scales: {
                        yAxes: [
                            {
                                id: 'left',
                                type: 'linear',
                                ticks: {
                                    beginAtZero: true
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: '金额(元)',
                                    position: 'top'
                                }
                            },
                            {
                                id: 'right',
                                type: 'linear',
                                position: 'right',
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value) {
                                        return value + '%'
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: '百分比',
                                    position: 'top'
                                }
                            },
                        ]
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                    },
                    hover: {
                        mode: 'index',
                        intersect: false,
                    },
                    backgroundColor: 'transparent'
                }
            })
            this.chart.update()
        },
        accessTo(route) {
            let controller = 'IndexController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        changeTeam() {},
        changeWorker() {},
    },
}
